import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";

import eyeIcon from "../../../assets/images/app/allaya/eye-icon.svg";
import editIcon from "../../../assets/images/app/allaya/edit-icon.svg";
import deleteIcon from "../../../assets/images/app/allaya/delete-icon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/images/app/allaya/filter-autocomplete.svg";

import { SearchBox } from "../../../components/SearchBox";
// import AudioFilterModal from "../AudioFilterModal";
// import { FilterChips } from "../FilterChips";
import { transformFiltersToArray, truncateString } from "../../../utils/commonUtils";
import { DataTable } from "../../../components/DataTable";
import { LABELS } from "../Config";
import { UserStatus } from "../../../constants";
import { APP_ROUTES, getParamsAttachedRoute } from "../../../helpers/routeHelpers";
import { getKey, MODULE_KEYS } from "../../../api/api.keys";
import { useLocalPaginatedRequest } from "../../../hooks/useLocalPaginatedRequest";
import { DeleteGoalById, GetGoalListing } from "../../../api/api.service";
import { Pagination } from "../../../components/Pagination";
import { ConfirmationModal } from "../../../components/CustomModal";
import { useRequestProcessor } from "../../../hooks/useRequestProcessors";
import GoalStatus, { GOAL_STATUS } from "../../../constants/GoalStatus";
import GoalFilterModal from "../GoalFilterModal";
import { FilterChips } from "../../AudioContentManagement/FilterChips";
import { SortOrderText } from "../../../constants/SortOrder";

let { GOAL_NAME, GOAL_ORDER, STATUS, ACTION } = LABELS;

const GOALS = {
    PRIMARY: "PRIMARY",
    SECONDARY: "SECONDARY"
};

const GoalListing = () => {
    const history = useHistory();
    const location = useLocation();
    const type = location?.pathname.split("/").pop();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState();
    const { useMutate } = useRequestProcessor();

    const { mutate: deleteJobMutate, isLoading } = useMutate("", getKey(), (data) =>
        DeleteGoalById(selectedId)
    );

    const [isFilterModal, setIsFilterModal] = useState(false);
    const [filters, setFilters] = useState({
        subCategory: [],
        status: [],
        audioType: []
    });

    const {
        isFetching,
        page,
        handlePageClick,
        total,
        data,
        searchText,
        limit,
        handleSearchChange,
        handleSortingChange,
        refetch
    } = useLocalPaginatedRequest({
        key: getKey([MODULE_KEYS.GOAL_MANGEMENT]),
        requestFn: GetGoalListing,
        dataKey: "data",
        totalKey: "total",
        params: {
            type: type === "secondary" ? GOALS.SECONDARY : GOALS.PRIMARY,
            ...(filters.status?.value && {
                status:
                    filters.status?.value === "Active" ? GOAL_STATUS.ACTIVE : GOAL_STATUS.INACTIVE
            }),
            direction: SortOrderText.DESC,
            column: "priorityNumber"
        }
    });

    const openFilterModal = () => setIsFilterModal(true);

    const handleApplyFilter = (newFilters) => {
        setFilters(newFilters);
        setIsFilterModal(false);
    };

    const handleRemoveFilter = (type, value) => {
        setFilters((prevFilters) => {
            const updatedFilters = { ...prevFilters };

            if (Array.isArray(updatedFilters[type])) {
                updatedFilters[type] = updatedFilters[type].filter((item) => item.value !== value);
            }

            if (typeof updatedFilters[type] === "object" && updatedFilters[type] !== null) {
                if (updatedFilters[type].value === value) {
                    updatedFilters[type] = null;
                }
            }

            return updatedFilters;
        });
    };

    const handleDeleteGoal = () => {
        deleteJobMutate(Number(selectedId), {
            onSuccess: () => {
                refetch();
                setIsDeleteModalOpen(false);
                setSelectedId(undefined);
            }
        });
    };

    return (
        <div>
            <Row className="px-3">
                <Col sm="12" md="4" lg="4" className="pt-3">
                    <SearchBox
                        className="me-3 w-50"
                        value={searchText}
                        onChange={handleSearchChange}
                    />
                </Col>
                <Col sm="12" md="5" lg="5"></Col>

                <Col sm="12" md="3" lg="3" className="pt-3">
                    <div
                        className={`filter-container d-flex justify-content-between align-items-center pointer`}
                        onClick={openFilterModal}
                    >
                        <div className="position-relative filter-text">Filter By</div>
                        <div className="">
                            <FilterIcon />
                        </div>
                    </div>
                </Col>
            </Row>
            <Row className="pb-3 align-items-center">
                <Col sm="12" md="6" lg="6"></Col>
            </Row>

            <Row className="px-3 my-2">
                <FilterChips
                    filters={transformFiltersToArray(filters)}
                    onRemove={handleRemoveFilter}
                />
            </Row>

            <DataTable
                tableContainerClass=""
                loading={isFetching}
                data={data}
                config={[
                    {
                        title: GOAL_NAME,
                        render: (data) => <div>{truncateString(data?.name, 30) || "-"}</div>
                    },
                    {
                        title: GOAL_ORDER,
                        render: (data) => <div>{data?.priorityNumber || "-"}</div>
                    },
                    {
                        title: STATUS,
                        render: (data) => (
                            <div
                                className={`status-common-class ${UserStatus.getLabelClass(
                                    data?.status
                                )}`}
                            >
                                {GoalStatus.getDisplayTextKey(data?.status) || "-"}
                            </div>
                        )
                    },
                    {
                        title: ACTION,
                        render: (data) => {
                            return (
                                <div className="d-flex ">
                                    <img
                                        className="me-1"
                                        src={eyeIcon}
                                        alt={"view"}
                                        role="button"
                                        onClick={() => {
                                            const route =
                                                type === "secondary"
                                                    ? getParamsAttachedRoute(
                                                          APP_ROUTES.GOAL_SECONDARY_DETAIL,

                                                          { id: data?.id }
                                                      )
                                                    : getParamsAttachedRoute(
                                                          APP_ROUTES.GOAL_PRIMARY_DETAIL,
                                                          { id: data?.id }
                                                      );

                                            history.push(route);
                                        }}
                                    />

                                    <img
                                        className="me-2"
                                        src={editIcon}
                                        alt={"edit"}
                                        role="button"
                                        onClick={() => {
                                            const route =
                                                type === "secondary"
                                                    ? getParamsAttachedRoute(
                                                          APP_ROUTES.GOAL_MANAGEMENT_SECONDARY_EDIT,

                                                          { id: data?.id }
                                                      )
                                                    : getParamsAttachedRoute(
                                                          APP_ROUTES.GOAL_MANAGEMENT_PRIMARY_EDIT,
                                                          { id: data?.id }
                                                      );
                                            // history.push(
                                            //     getParamsAttachedRoute(
                                            //         APP_ROUTES.GOAL_MANAGEMENT_EDIT,
                                            //         {
                                            //             id: data?.id
                                            //         }
                                            //     )
                                            // )
                                            history.push(route);
                                        }}
                                    />
                                    <img
                                        className="me-1"
                                        src={deleteIcon}
                                        alt={"delete"}
                                        role="button"
                                        onClick={() => {
                                            setSelectedId(data?.id);
                                            setIsDeleteModalOpen(true);
                                        }}
                                    />
                                </div>
                            );
                        }
                    }
                ]}
            />

            <Pagination
                rowLimit={limit}
                onPageClick={handlePageClick}
                currentPage={page}
                totalData={total}
                handleChange={(e) => handleSortingChange(e.target.value)}
            />

            <ConfirmationModal
                size="md"
                hasCustomConfig
                customSubText={"Are you sure you want to delete this goal?"}
                customYesBtnText={"Delete"}
                customNoBtnText={"Cancel"}
                isOpen={isDeleteModalOpen}
                onYes={handleDeleteGoal}
                onNo={() => setIsDeleteModalOpen(false)}
                yesLoading={isLoading}
                customImageSrc={deleteIcon}
            />

            <GoalFilterModal
                isModalOpen={isFilterModal}
                handleClose={() => setIsFilterModal(false)}
                handleApplyFilter={handleApplyFilter}
                selectedFilters={filters} // Pass the current filters to the modal
            />
        </div>
    );
};

export default GoalListing;
